import Vue from 'vue'

import VueSignaturePad from 'vue-signature-pad'

Vue.use(VueSignaturePad);
